import { anyReallyAny } from "@cervval.js/common/tools";
import { DialogOptions, showErrorInDialog } from "../components/dialog/dialog";
import { ErrorDisplayOptions } from "../components/errorDisplay/errorDisplay";

/** 
 * Method or get Accessor decorator that wraps the method with a try catch(e){showErrorInDialog(e,dialogOptions)}
 * ! In case there is an error, always returns a Promise
 */
export function CatchErrorWithDialog(dialogOptions?: Partial<DialogOptions> & Partial<ErrorDisplayOptions>) {
    return function (target: unknown, propertyKey: string, descriptor: PropertyDescriptor): PropertyDescriptor {
        if (descriptor.get) {
            // get accessor
            const originalGet = descriptor.get;
            descriptor.get = function (): unknown {
                try {
                    const ret = originalGet.apply(this);
                    if (ret instanceof Promise) {
                        return ret.catch((e) => showErrorInDialog(e, dialogOptions));
                    }
                    return ret;
                } catch (e) {
                    showErrorInDialog(e, dialogOptions);
                }
                return Promise.resolve(undefined);
            };
        } else {
            // Method
            const originalValue = descriptor.value;
            descriptor.value = function (...args: anyReallyAny[]): unknown {
                try {
                    const ret = originalValue.apply(this, args);
                    if (ret instanceof Promise) {
                        return ret.catch((e) => showErrorInDialog(e, dialogOptions));
                    }
                    return ret;
                } catch (e) {
                    showErrorInDialog(e, dialogOptions);
                }
                return Promise.resolve(undefined);
            };
        }

        return descriptor;
    };
}
